var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedalGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_21983_222764)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.5652C17.2829 21.5652 21.5652 17.2829 21.5652 12.0004C21.5652 6.71788 17.2829 2.43555 12.0004 2.43555C6.71788 2.43555 2.43555 6.71788 2.43555 12.0004C2.43555 17.2829 6.71788 21.5652 12.0004 21.5652Z",
    fill: "url(#paint1_linear_21983_222764)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 20.212C16.5337 20.212 20.2101 16.5356 20.2101 12.0005C20.2101 7.46547 16.5337 3.78906 11.9986 3.78906C7.46352 3.78906 3.78711 7.46547 3.78711 12.0005C3.78711 16.5356 7.46352 20.212 11.9986 20.212Z",
    fill: "url(#paint2_linear_21983_222764)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0006C0 18.6281 5.37256 24.0006 12 24.0006C18.6274 24.0006 24 18.6281 24 12.0006C24 11.9541 23.9988 11.9078 23.9983 11.8613H0.00173576C0.00120755 11.9078 0 11.9541 0 12.0006Z",
    fill: "url(#paint3_linear_21983_222764)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21983_222764",
    x1: 4.60151,
    y1: 4.60151,
    x2: 17.2573,
    y2: 17.2573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21983_222764",
    x1: 18.2127,
    y1: 18.2127,
    x2: 5.60688,
    y2: 5.60688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21983_222764",
    x1: 6.02908,
    y1: 6.03104,
    x2: 15.8552,
    y2: 15.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21983_222764",
    x1: 12,
    y1: 15.5116,
    x2: 12,
    y2: 23.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGold);
export default __webpack_public_path__ + "static/media/medal_gold.c4de71ab9ac212187560cadc56310793.svg";
export { ForwardRef as ReactComponent };